(() => {
  'use strict';
  const campaignKeys = new Set(['utm_source','utm_medium','utm_campaign','utm_id','utm_content','utm_term','gclid','fbclid','ttclid','msclkid','gbraid','wbraid']);
  function mount(root) {
    if (root.dataset.cqMounted === 'true') return;
    root.dataset.cqMounted = 'true';
    const $ = selector => root.querySelector(selector);
    const all = selector => [...root.querySelectorAll(selector)];
    let config = {};
    try { config = JSON.parse($('[data-cq-config]').textContent); } catch (_) { /* Safe blank destination. */ }
    if (config.autoAdvance === false) $('[data-cq-flow-note]').textContent='Wähle eine Antwort und tippe auf Weiter';
    const screens = all('.screen');
    const answers = Array(screens.length).fill(null);
    const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = 0, phase = 'questions', advanceTimer = null, loadingTimer = null, generation = 0;
    const controller = new AbortController();
    const on = (target,type,callback) => target.addEventListener(type,callback,{signal:controller.signal});
    const stopTimers = () => { clearTimeout(advanceTimer); clearTimeout(loadingTimer); advanceTimer = loadingTimer = null; generation += 1; };
    const focus = element => { if (element) element.focus({preventScroll:true}); };
    function scrollFlow() {
      const top = $('.cq-flow').getBoundingClientRect().top + window.scrollY - 94;
      window.scrollTo({top:Math.max(0,top),behavior:reduceMotion?'instant':'smooth'});
    }
    function refresh() {
      const completed = answers.filter(value => value !== null).length;
      $('[data-cq-fill]').style.width = `${completed/screens.length*100}%`;
      $('[data-cq-progress]').setAttribute('aria-valuenow',String(completed));
      $('[data-cq-count]').textContent = `Frage ${current+1} / ${screens.length}`;
      $('[data-cq-completed]').textContent = `${completed} / ${screens.length} Antworten`;
      $('[data-cq-back]').disabled = current === 0;
      $('[data-cq-next]').disabled = answers[current] === null;
      $('[data-cq-next-text]').textContent = current === screens.length-1 ? 'Abschluss ansehen' : 'Weiter';
      all('.opt').forEach(label => label.classList.toggle('sel',label.querySelector('input').checked));
    }
    function go(index,scroll=true) {
      stopTimers(); phase = 'questions'; current = Math.min(screens.length-1,Math.max(0,index));
      root.classList.remove('cq-result-mode');
      document.querySelectorAll('[data-cq-commercial]').forEach(element => { element.hidden = true; });
      $('[data-cq-quiz-area]').hidden = false;
      $('[data-cq-progress-wrap]').hidden = false;
      $('[data-cq-navigation]').hidden = false;
      $('[data-cq-loading]').hidden = true;
      $('[data-cq-results]').hidden = true;
      $('[data-cq-sticky]').classList.remove('on');
      screens.forEach((screen,i) => { screen.hidden = i !== current; screen.classList.toggle('active',i===current); });
      refresh();
      if (scroll) { focus(screens[current].querySelector('.q-title')); scrollFlow(); }
    }
    function showResults() {
      phase = 'results';
      $('[data-cq-loading]').hidden = true;
      $('[data-cq-results]').hidden = false;
      root.classList.add('cq-result-mode');
      document.querySelectorAll('[data-cq-commercial]').forEach(element => { element.hidden = false; });
      $('[data-cq-sticky]').classList.add('on');
      focus($('[data-cq-results] h1')); scrollFlow();
    }
    function load() {
      if (phase !== 'questions' || answers.some(value => value === null)) return;
      stopTimers(); phase = 'loading';
      $('[data-cq-quiz-area]').hidden = true;
      $('[data-cq-progress-wrap]').hidden = true;
      $('[data-cq-loading]').hidden = false;
      const steps = all('.l-step');
      steps.forEach((step,i) => { step.classList.remove('on','ok'); step.querySelector('.ic').textContent=String(i+1); });
      $('[data-cq-loading-bar]').style.width = '0%';
      $('[data-cq-loading-pct]').textContent = '0%';
      focus($('[data-cq-loading] h2')); scrollFlow();
      const ticket = generation;
      const tick = index => {
        if (ticket !== generation || phase !== 'loading') return;
        if (index === steps.length) { showResults(); return; }
        steps[index].classList.add('on');
        loadingTimer = setTimeout(() => {
          if (ticket !== generation || phase !== 'loading') return;
          steps[index].classList.remove('on'); steps[index].classList.add('ok');
          steps[index].querySelector('.ic').textContent = '✓';
          const percent = Math.round((index+1)/steps.length*100);
          $('[data-cq-loading-bar]').style.width = `${percent}%`;
          $('[data-cq-loading-pct]').textContent = `${percent}%`;
          tick(index+1);
        },reduceMotion?120:410);
      };
      tick(0);
    }
    function next() {
      if (phase !== 'questions' || answers[current] === null) return;
      clearTimeout(advanceTimer);
      if (current === screens.length-1) load(); else go(current+1);
    }
    on(root,'change',event => {
      const input = event.target.closest('input[data-cq-answer]');
      if (!input || phase !== 'questions' || !screens[current].contains(input)) return;
      answers[current] = Number(input.value); refresh(); clearTimeout(advanceTimer);
      if (config.autoAdvance !== false) advanceTimer = setTimeout(next,450);
    });
    on($('[data-cq-back]'),'click',() => { if(current>0)go(current-1); });
    on($('[data-cq-next]'),'click',next);
    on($('[data-cq-cancel-loading]'),'click',() => go(screens.length-1));
    on($('[data-cq-review]'),'click',() => go(0));
    on($('[data-cq-restart]'),'click',() => {
      answers.fill(null); all('input[data-cq-answer]').forEach(input => { input.checked=false; }); go(0);
    });
    let destination = null;
    try {
      const raw = String(config.destinationUrl || '').trim();
      if (raw && !raw.startsWith('#')) {
        const candidate = new URL(raw,window.location.href);
        if (['http:','https:'].includes(candidate.protocol)) {
          if (config.preserveCampaign !== false) {
            new URLSearchParams(window.location.search).forEach((value,key) => {
              if (campaignKeys.has(key) && !candidate.searchParams.has(key)) candidate.searchParams.set(key,value);
            });
          }
          destination = candidate.href;
        }
      }
    } catch (_) { /* Invalid URLs remain disabled. */ }
    all('[data-cq-destination]').forEach(anchor => {
      anchor.href = destination || '#';
      anchor.setAttribute('aria-disabled',String(!destination));
      if (!destination) on(anchor,'click',event => {
        event.preventDefault();
        $('[data-cq-link-status]').hidden=false;
        $('[data-cq-link-status]').textContent='Der Link ist noch nicht verfügbar.';
      });
    });
    if (!destination) $('[data-cq-link-status]').hidden=false;
    // Answers remain in memory. Do not add answers, ages or health information to URLs or analytics.
    root._cqCleanup = () => { stopTimers(); controller.abort(); };
    go(0,false);
  }
  function mountAll(parent=document) { parent.querySelectorAll('[data-caldora-quiz]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => mountAll(),{once:true}); else mountAll();
  document.addEventListener('shopify:section:load',event => mountAll(event.target));
  document.addEventListener('shopify:section:unload',event => event.target.querySelectorAll('[data-caldora-quiz]').forEach(root => root._cqCleanup?.()));
})();
